/* 付款阶段显示 */

<template>
  <div class="phase">
    <Tooltip content="Bottom Center text" :placement="position" theme="light" max-width="500">
      <i class="iconfont" :class="icon"></i>
      <div slot="content" class="tool-content">
        <p>{{title}}</p>
        <ul v-if="steps && steps.length > 0">
          <li v-for="(item, index) in steps" :key="index" v-if="item.comment">
            <p class="title">
              <span>{{item.stgTitle}}</span>
              <span v-if="item.paymentPercent">（总价{{item.paymentPercent}}%)：</span>
              <span
                class="c-red"
                v-if="item.paymentAmount"
              >{{item.paymentAmount | currency('¥', '2')}}</span>
              <!-- <span v-if="item.plannedDay" class="pannlDay">周期：{{item.plannedDay}}天</span> -->
            </p>
            <p class="insert-detail">{{item.comment}}</p>
          </li>
        </ul>
      </div>
    </Tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: "付款阶段"
    },
    icon: {
      type: String,
      default: "icon-exclamationpoint"
    },
    steps: {
      type: Array,
      default: function() {
        return [];
      }
    },
    position: {
      type: String,
      default: "bottom-start"
    }
  }
};
</script>

<style lang="scss">
.phase {
  display: inline-block;
  margin-left: 0px;
  vertical-align: top;
  cursor: pointer;
  i {
    margin-top: -4px;
    display: inline-block;
    color: #e56a69;
    font-size: 22px;
  }
  p {
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
  }
  li {
    width: 100%;
    margin-top: 20px;
    text-align: left;
    p:first-child {
      font-size: 14px;
      color: rgba(62, 62, 62, 1);
      .pannlDay {
        float: right;
        color: #f5a623;
      }
    }
    .title {
      text-align: left;
      margin-bottom: 10px;
      display: inline-block;
      margin-left: 0px;
      width: 100%;
    }
    .insert-detail {
      color: #949292;
      text-align: left;
    }
  }
  .ivu-tooltip-inner {
    width: 500px;
    padding: 20px;
  }
}
</style>


